import { ref, onMounted, onBeforeUnmount } from 'vue';
import type { Ref } from 'vue';

export function useDropdownState(containerRef: Ref<HTMLElement | undefined>) {
  const isOpen = ref(false);

  function open(): void {
    isOpen.value = true;
  }

  function close(): void {
    isOpen.value = false;
  }

  function toggle(): void {
    isOpen.value = !isOpen.value;
  }

  function handleDocumentClick(e: MouseEvent): void {
    if (isOpen.value && containerRef.value && !containerRef.value.contains(e.target as Node)) {
      close();
    }
  }

  onMounted(() => document.addEventListener('click', handleDocumentClick));
  onBeforeUnmount(() => document.removeEventListener('click', handleDocumentClick));

  return { isOpen, open, close, toggle };
}

export function useDropdownGroup(containerRef: Ref<HTMLElement | undefined>) {
  const active = ref<string | null>(null);

  function toggle(name: string): void {
    active.value = active.value === name ? null : name;
  }

  function isOpen(name: string): boolean {
    return active.value === name;
  }

  function open(name: string): void {
    active.value = name;
  }

  function close(): void {
    active.value = null;
  }

  function handleDocumentClick(e: MouseEvent): void {
    if (active.value && containerRef.value && !containerRef.value.contains(e.target as Node)) {
      close();
    }
  }

  onMounted(() => document.addEventListener('click', handleDocumentClick));
  onBeforeUnmount(() => document.removeEventListener('click', handleDocumentClick));

  return { active, toggle, isOpen, open, close };
}
